import { render, staticRenderFns } from "./GebruikerAanpassen.vue?vue&type=template&id=3a40f412&scoped=true&"
import script from "./GebruikerAanpassen.vue?vue&type=script&lang=js&"
export * from "./GebruikerAanpassen.vue?vue&type=script&lang=js&"
import style0 from "./GebruikerAanpassen.vue?vue&type=style&index=0&id=3a40f412&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a40f412",
  null
  
)

export default component.exports